export const heroTranslations = {
  nl: {
    cuisineType: "🇮🇳 &nbsp; 🇱🇰 &nbsp; 🇸🇷 &nbsp; Delicatessen",
    title: "Authentieke Smaken bij",
    brandName: "Ams Food Market",
    subtitle: "Ontdek een wereld van smaak met onze verse Indiase, Sri Lankaanse en Surinaamse producten, groenten en heerlijke gekookte maaltijden. Gevestigd in het hart van Lelystad.",
    viewMenu: "Bekijk Ons Menu",
    findUs: "Vind Ons",
    freshAuthentic: "Vers & Authentiek",
    dailyMeals: "Dagelijks Bereide Maaltijden",
  },
  en: {
    cuisineType: "🇮🇳 &nbsp; 🇱🇰 &nbsp; 🇸🇷 &nbsp; Delicacies",
    title: "Authentic Flavors at",
    brandName: "Ams Food Market",
    subtitle: "Discover a world of taste with our fresh Indian, Sri Lankan, and Surinamese products, vegetables, and delicious cooked meals. Located in the heart of Lelystad.",
    viewMenu: "View Our Menu",
    findUs: "Find Us",
    freshAuthentic: "Fresh & Authentic",
    dailyMeals: "Daily Prepared Meals",
  },
};